<template>
  <v-card>
    <div class="example" align="center">
      <v-container>
        <v-row>
          <v-col>
            <div align="left">フォームの追加:{{ j }}-{{ i }}</div>
          </v-col>
        </v-row>
        <v-row>
          <!-- 四方コピーボタン------>
          <v-col
            v-for="(form, index) in FormCopys"
            :key="`first-${index}`"
            cols="3"
            @click="check(form)"
            class="ma-0 mp-0"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-sheet
                  :color="getcolor(form)"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  min-height="20"
                  class="ma-0 pa-0"
                >
                  {{ form.name }}
                </v-sheet>
              </template>
              <span>{{ form.text }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row>
          <!-- 各種フォームの表示------>
          <v-col
            v-for="(form, index) in formTypes"
            :key="`Second-${index}`"
            cols="4"
            @click="check(form)"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-sheet
                  :color="getcolor(form)"
                  outlined
                  v-if="view(form)"
                  v-bind="attrs"
                  v-on="on"
                  min-height="20"
                >
                  {{ form.name }}
                </v-sheet>
              </template>
              <span>{{ form.text }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row>
          <!-- フォーム詰め合わせ------>
          <v-col
            v-for="(form, index) in FormSets"
            :key="`first-${index}`"
            cols="4"
            @click="check(form)"
            class="ma-0 mp-0"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-sheet
                  :color="getcolor(form)"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  min-height="20"
                  class="ma-0 pa-0"
                >
                  {{ form.name }}
                </v-sheet>
              </template>
              <span>{{ form.text }}</span>
            </v-tooltip>
          </v-col>
        </v-row>

        <div align="right">
          <v-btn
            color="primary"
            @click.once="submit"
            :disabled="selectFromType == 0"
            large
            fixed
            bottom
          >
            決定
          </v-btn>
        </div>
      </v-container>
    </div>
  </v-card>
</template>

<script>
import mudamieru_btnset from "./mudamieru_btnset";
import mudamieru_worktimeset from "./mudamieru_worktimeset";
import mudamieru_subset from "./mudamieru_subset";

export default {
  props: {
    formTypes: Array,
    i: Number,
    j: Number,
  },
  data() {
    return {
      FormCopys: [
        {
          type: -1,
          name: "←コピー",
          text: "左隣のフォームをコピー",
          //
        },
        {
          type: -2,
          name: "→コピー",
          text: "右隣のフォームをコピー",
          //
        },
        {
          type: -3,
          name: "↑コピー",
          text: "真上のフォームをコピー",
          //
        },
        {
          type: -4,
          name: "↓コピー",
          text: "真下のフォームをコピー",
          //
        },
      ],
      FormSets: [
        {
          type: -5,
          name: "[ムダミエール]ボタンセット",
          text: "(開始/中断/再開/終了)を1度に作成",
          label: "ムダミエールボタンセット",
          cols: "0",
          //
          arr: mudamieru_btnset,
        },
        {
          type: -6,
          name: "[ムダミエール]作業時間セット",
          text: "(稼働時間/中断時間/実稼働時間)を1度に作成",
          label: "ムダミエール作業時間セット",
          cols: "0",
          arr: mudamieru_worktimeset,
        },
        {
          type: -7,
          name: "[ムダミエール]中断時間セット",
          text: "(中断開始/中断終了/中断時間/中断理由)を1度に作成",
          label: "ムダミエール中断時間セット",
          cols: "0",
          arr: mudamieru_subset,
        },
      ],
      //返却値
      returnData: {
        form: {},
        forms: [],
      },
      //変数
      selectFromType: 0,
    };
  },
  mounted() {
    if (this.value != null && this.value != "") {
      this.form_check = true;
    }
  },
  methods: {
    check(form) {
      this.selectFromType = form.type;
    },
    getcolor(form) {
      let color = "blue-grey lighten-4";
      if (this.selectFromType == 0 || form.type == this.selectFromType) {
        switch (form.type) {
          case 1: //テキスト
            color = "#a0d8ef";
            break;
          case 2: //セレクトボックス
            color = "#fffacd";
            break;
          case 3: //日付
            color = "#86E1E3";
            break;
          case 7: //ラジオボタン
            color = "#009688";
            break;
          case 14: //チェックボックス
            color = "#AFB42B";
            break;
          case 15: //時刻
            color = "#E88066";
            break;
          case 16: //ボタン
            color = "#f08080";
            break;
          case 17: //サブページ
            color = "#7fffd4";
            break;
          case 18: //ユーザ情報
            color = "#E65100";
            break;
          case 20: //送信ボタンオプション
            color = "#eebbc3";
            break;
          case 22: //削除ボタンオプション
            color = "#b8c1ec";
            break;
          case 24: //div
            color = "orange";
            break;
          case 37: //マスタ取得/格納フォーム
            color = "#A1887F";
            break;
          default:
            color = "#FFF3E0"; //デフォルトページ
        }
      }
      return color;
    },
    view(form) {
      return typeof form.type !== "undefined";
    },
    submit() {
      if (this.selectFromType < -4) {
        //セット処理
        let data = this.FormSets.filter((f) => f.type == this.selectFromType);
        this.returnData.form = data[0];
        this.returnData.forms = data[0].arr;
        this.$emit("close", this.returnData);
      } else if (this.selectFromType < 0) {
        //コピー処理
        let data = this.FormCopys.filter((f) => f.type == this.selectFromType);
        this.returnData.form = data[0];
        this.$emit("close", this.returnData);
      } else {
        let data = this.formTypes.filter((f) => f.type == this.selectFromType);
        if (data.length == 1) {
          this.returnData.form = data[0];
          this.$emit("close", this.returnData);
        }
      }
    },
  },
};
</script>
